import Api from '@/services/API';


/**
 * @typedef {ValidatePurchase}
 */

export default class ValidatePurchase extends Api {
  /**
   * @type {String}
   */
  static base = process.env.VUE_APP_API_HOST

  /**
   * @type {String}
   */
  static resource = '/member/new/validate-purchase'

  /**
   * @param {String} resource
   * @param {Object} options
   * @param {Object} http
   */
  constructor(resource, options = {}, http = null) {
    super(ValidatePurchase.normalize(ValidatePurchase.base, resource), options, http);
  }

  /**
   * @return {this}
   */
  static build() {
    return new this(this.resource);
  }

  validatePurchase(email, document) {
    let data = {
      email: email,
      document: document
    }

    return this.post('', data);
  }
}